<template>
	<el-dialog
		title="新增支出预算"
		:visible.sync="dialogVisible"
		width="35%"
		top="10vh"
		:close-on-click-modal="false"
		:before-close="handleClose"
		custom-class="depreciation-dialog">
		<!-- 表格 -->
		<el-form ref="form" :model="form" :rules="rules" label-position="top" size="mini">
			<el-row :gutter="20">
				<!-- 预算科目 -->
				<el-col :span="24">
					<el-form-item label="预算科目" prop="budgetSubject">
						<el-input v-model="form.budgetSubject" size="small" placeholder="请输入预算科目" />
					</el-form-item>
				</el-col>

				<!-- 年份 -->
				<el-col :span="12">
					<el-form-item label="年份" prop="year">
						<el-date-picker
							v-model="form.year"
							type="year"
							placeholder="选择年份"
							value-format="yyyy"
							format="yyyy"
							style="width: 100%"
							size="small" />
					</el-form-item>
				</el-col>

				<!-- 月份 -->
				<el-col :span="12">
					<el-form-item label="月份" prop="month">
						<el-date-picker
							v-model="form.month"
							type="month"
							placeholder="选择月份"
							value-format="yyyy-MM"
							format="yyyy-MM"
							style="width: 100%"
							size="small" />
					</el-form-item>
				</el-col>

				<!-- 备注 -->
				<el-col :span="24">
					<el-form-item label="备注" prop="remark">
						<el-input type="textarea" v-model="form.remark" size="small" placeholder="请输入备注" :rows="4" />
					</el-form-item>
				</el-col>
			</el-row>
		</el-form>
		<span slot="footer">
			<el-button @click="handleClose">取 消</el-button>
			<el-button type="primary" @click="handleSubmit">确 定</el-button>
		</span>
	</el-dialog>
</template>

<script>
	export default {
		name: 'BudgetManagementDialog',
		props: {
			dialogVisible: Boolean,
			data: {
				type: Object,
				default: () => ({}),
			},
		},
		watch: {
			dialogVisible(val) {
				if (val) {
					this.$nextTick(() => {
						this.$refs.form && this.$refs.form.resetFields();
					});
				}
			},
		},
		data() {
			return {
				form: {
					budgetSubject: '',
					year: '',
					month: '',
					remark: '',
				},
				rules: {
					budgetSubject: [{ required: true, message: '请输入预算科目', trigger: 'blur' }],
					year: [{ required: true, message: '请选择年份', trigger: 'change' }],
					month: [{ required: true, message: '请选择月份', trigger: 'change' }],
				},
			};
		},
		created() {},
		methods: {
			handleClose() {
				this.$emit('update:dialogVisible', false);
			},
			handleSubmit() {},
		},
	};
</script>

<style scoped lang="scss">
	:deep(.depreciation-dialog) {
		.el-dialog__body {
			max-height: 60vh; // 控制最大高度
			overflow-y: auto; // 开启纵向滚动
		}
		/* 整体滚动条宽度 */
		.el-dialog__body::-webkit-scrollbar {
			width: 6px;
		}

		/* 滚动条轨道 */
		.el-dialog__body::-webkit-scrollbar-track {
			background: #f5f5f5;
			border-radius: 3px;
		}

		/* 滑块 */
		.el-dialog__body::-webkit-scrollbar-thumb {
			background: #bbbbbb;
			border-radius: 3px;
			transition: all 0.3s;
		}

		/* hover 时 */
		.el-dialog__body::-webkit-scrollbar-thumb:hover {
			background: #a8a8a8;
		}
	}
</style>
